var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4ef53416"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex flex-row text-gray-400 items-center" };
const _hoisted_2 = {
    key: 0,
    class: "flex flex-row text-gray-400 items-center"
};
const _hoisted_3 = { id: "availableDaySlotPicker" };
const _hoisted_4 = { class: "chat-widget-business-hours-weekday" };
const _hoisted_5 = { class: "radio-icon-group" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["id"];
const _hoisted_8 = { class: "flex w-full items-center" };
const _hoisted_9 = {
    key: 0,
    class: "w-full"
};
const _hoisted_10 = { class: "flex items-center pt-2" };
const _hoisted_11 = { class: "px-2 font-semibold" };
const _hoisted_12 = { class: "flex items-center" };
const _hoisted_13 = { class: "w-40" };
const _hoisted_14 = { class: "text-md mt-0 px-0.5 font-normal text-gray-600" };
const _hoisted_15 = { class: "font-md mr-32 w-full font-semibold text-gray-700" };
const _hoisted_16 = { class: "font-md mr-32 w-full font-semibold text-gray-700" };
const _hoisted_17 = {
    key: 0,
    class: "text-left text-sm text-red-600 mt-1"
};
import { appState } from '@/composable/appState';
import { CHAT_WIDGET_IDS } from '@/helper/const';
import { generateDefaultOpenHours, getLocalizedDay } from '@/helper/helper';
import { MyAvailability } from '@/helper/MyAvailability';
import { i18n } from '@/plugin/vue-i18n';
import { Copy06Icon, InfoCircleIcon, PlusIcon, Trash02Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton, UICheckbox, UIForm, UIFormItem, UIInput, UIPopover, UISwitch, UITextSmMedium, UITimePicker, UITooltip, } from '@gohighlevel/ghl-ui';
import moment from 'moment';
import { computed, reactive, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BusinessOfficeHourSetup',
    setup(__props, { expose }) {
        const myAvailability = ref(new MyAvailability(''));
        const openHourRef = ref();
        const copyToDays = ref([]);
        const activeHourIndexForCopy = ref(-1);
        const businessHoursData = reactive({
            value: {},
        });
        const loadData = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const { openHours } = ((_b = (_a = appState === null || appState === void 0 ? void 0 : appState.chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.advanceSettings) === null || _b === void 0 ? void 0 : _b.businessOfficeHours) || {};
            myAvailability.value.setOpenHoursDataFromDatabase(Array.isArray(openHours) ? openHours : []);
            initializeVisibilityState();
        });
        expose({ loadData });
        const handleIsHourDisabled = (hour, startTime) => {
            const startHour = moment(startTime, 'H:m').hour();
            return hour !== 0 && hour < startHour;
        };
        const handleIsMinDisabled = (min, hour, startTime) => {
            const startMin = moment(startTime, 'H:m').minute();
            const startHour = moment(startTime, 'H:m').hour();
            return hour !== 0 && hour === startHour && min <= startMin;
        };
        const handleEnableBusinessOfficeHour = (val) => {
            var _a;
            const { businessOfficeHours } = appState.chatWidgetSettingsData.advanceSettings;
            businessOfficeHours.enableBusinessHours = val;
            if (val) {
                const defaultOpenHours = generateDefaultOpenHours([1, 2, 3, 4, 5]);
                businessOfficeHours.openHours =
                    ((_a = businessOfficeHours === null || businessOfficeHours === void 0 ? void 0 : businessOfficeHours.openHours) === null || _a === void 0 ? void 0 : _a.length) > 0
                        ? businessOfficeHours.openHours
                        : defaultOpenHours;
                loadData();
            }
            appState.unsavedChanges = true;
        };
        const getSelectedDaysWithTimes = () => {
            const openHours = myAvailability.value.availableDays
                .filter(day => day.hours.length > 0)
                .map(day => ({
                daysOfTheWeek: [day.dayOfWeek],
                hours: day.hours.map(hour => ({
                    openHour: hour.startTime.split(':')[0],
                    openMinute: hour.startTime.split(':')[1],
                    closeHour: hour.endTime.split(':')[0],
                    closeMinute: hour.endTime.split(':')[1],
                })),
            }));
            const { businessOfficeHours } = appState.chatWidgetSettingsData.advanceSettings;
            const businessOfficeHoursData = {
                enableBusinessHours: businessOfficeHours === null || businessOfficeHours === void 0 ? void 0 : businessOfficeHours.enableBusinessHours,
                openHours,
                timezone: myAvailability.value.selectedUserTimezone,
                outsideOfficeHoursWelcomeMsg: businessOfficeHours === null || businessOfficeHours === void 0 ? void 0 : businessOfficeHours.outsideOfficeHoursWelcomeMsg,
            };
            appState.chatWidgetSettingsData.advanceSettings.businessOfficeHours =
                businessOfficeHoursData;
            return businessOfficeHoursData;
        };
        const handleOutsideOfficeHourCta = (val) => {
            const { businessOfficeHours } = appState.chatWidgetSettingsData.advanceSettings;
            businessOfficeHours.outsideOfficeHoursWelcomeMsg = val;
            appState.unsavedChanges = true;
        };
        const isBusinessHoursEnabled = computed(() => {
            var _a, _b, _c;
            return (((_c = (_b = (_a = appState.chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.advanceSettings) === null || _b === void 0 ? void 0 : _b.businessOfficeHours) === null || _c === void 0 ? void 0 : _c.enableBusinessHours) || false);
        });
        const updateBusinessOfficeHours = () => {
            const businessOfficeHours = getSelectedDaysWithTimes();
            appState.chatWidgetSettingsData.advanceSettings.businessOfficeHours =
                businessOfficeHours;
            const hasOverlap = myAvailability.value.availableDays.some(availableDay => availableDay.hours.some((_, hourIndex) => availableDay.isOverlapIndex(hourIndex)));
            appState.unsavedChanges = !hasOverlap;
            appState.getCodeButtonDisabled = hasOverlap;
        };
        const sortAvailableDays = (days) => {
            return days.sort((a, b) => {
                var _a, _b;
                return ((_a = MyAvailability.DAYS.find(day => day.name === a.day)) === null || _a === void 0 ? void 0 : _a.index) -
                    ((_b = MyAvailability.DAYS.find(day => day.name === b.day)) === null || _b === void 0 ? void 0 : _b.index);
            });
        };
        const initializeVisibilityState = () => {
            myAvailability.value.availableDays.forEach(day => {
                businessHoursData.value[`hide${day.day}`] = day.hours.length === 0;
            });
        };
        const toggleVisibility = (availableDay) => {
            const property = `hide${availableDay.day}`;
            businessHoursData.value[property] = !businessHoursData.value[property];
            if (businessHoursData.value[property]) {
                myAvailability.value.updateAvailabilityDay({
                    day: availableDay,
                    checked: false,
                });
            }
            else {
                myAvailability.value.updateAvailabilityDay({
                    day: availableDay,
                    checked: true,
                });
            }
        };
        const removeAvailabilityHour = (availableDay, hourIndex) => {
            availableDay.removeAvailabilityHour(hourIndex);
            if (availableDay.hours.length === 0) {
                toggleVisibility(availableDay);
            }
        };
        const copyTimesToDays = (availableDay) => {
            myAvailability.value.copyFromOneToMany(availableDay.day, copyToDays.value);
            copyToDays.value.forEach(dayName => {
                const day = myAvailability.value.availableDays.find(d => d.day === dayName);
                if (day) {
                    businessHoursData.value[`hide${day.day}`] = false;
                    myAvailability.value.updateAvailabilityDay({
                        day,
                        checked: true,
                        copy: true,
                    });
                }
            });
            copyToDays.value = [];
            activeHourIndexForCopy.value = -1;
        };
        const visibleDays = computed(() => {
            return sortAvailableDays(myAvailability.value.availableDays).filter(day => !businessHoursData.value[`hide${day.day}`]);
        });
        watch(() => myAvailability.value.availableDays, updateBusinessOfficeHours, {
            deep: true,
        });
        watch(() => loadData, (newValue, oldValue) => {
            if (newValue !== oldValue) {
                loadData();
            }
        }, { immediate: true });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_unref(UISwitch), {
                        rubberBand: false,
                        value: _unref(isBusinessHoursEnabled),
                        "onUpdate:value": handleEnableBusinessOfficeHour
                    }, null, 8 /* PROPS */, ["value"]),
                    _createVNode(_unref(UIFormItem), {
                        label: _ctx.$t('businessHour.enableBusinessOfficeHours'),
                        "show-feedback": false,
                        class: "ml-2 mt-2"
                    }, null, 8 /* PROPS */, ["label"]),
                    _createVNode(_unref(UITooltip), {
                        trigger: "hover",
                        style: { "width": "300px" },
                        placement: "left"
                    }, {
                        trigger: _withCtx(() => [
                            _createVNode(_unref(InfoCircleIcon), { class: "w-6 h-4" })
                        ]),
                        default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('sidebar.enableBusinessOfficeHoursHelper')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                (_unref(isBusinessHoursEnabled))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_unref(UIFormItem), {
                            class: "my-2",
                            label: _ctx.$t('sidebar.outsideOfficeHoursWelcomeMsg'),
                            "show-feedback": false
                        }, null, 8 /* PROPS */, ["label"]),
                        _createVNode(_unref(UITooltip), {
                            trigger: "hover",
                            placement: "left",
                            style: { "width": "300px" }
                        }, {
                            trigger: _withCtx(() => [
                                _createVNode(_unref(InfoCircleIcon), { class: "w-6 h-4 mb-2" })
                            ]),
                            default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('sidebar.outsideOfficeHoursWelcomeMsgHelper')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]))
                    : _createCommentVNode("v-if", true),
                (_unref(isBusinessHoursEnabled))
                    ? (_openBlock(), _createBlock(_unref(UIInput), {
                        key: 1,
                        rows: 4,
                        type: "textarea",
                        id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                        modelValue: (_c = (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.advanceSettings) === null || _b === void 0 ? void 0 : _b.businessOfficeHours) === null || _c === void 0 ? void 0 : _c.outsideOfficeHoursWelcomeMsg,
                        placeholder: _unref(i18n).global.t('placeholder.outsideOfficeHoursWelcomeMsg'),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = val => handleOutsideOfficeHourCta(val))
                    }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"]))
                    : _createCommentVNode("v-if", true),
                ((_d = _unref(appState).chatWidgetSettingsData.advanceSettings.businessOfficeHours) === null || _d === void 0 ? void 0 : _d.enableBusinessHours)
                    ? (_openBlock(), _createBlock(_unref(UIForm), {
                        key: 2,
                        id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_OPEN_HOURS,
                        ref_key: "openHourRef",
                        ref: openHourRef,
                        model: (_g = (_f = (_e = _unref(appState).chatWidgetSettingsData) === null || _e === void 0 ? void 0 : _e.advanceSettings) === null || _f === void 0 ? void 0 : _f.businessOfficeHours) === null || _g === void 0 ? void 0 : _g.openHours,
                        class: "w-full my-2"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_unref(UITextSmMedium), null, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('businessHour.availableHours')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortAvailableDays(myAvailability.value.availableDays), (availableDay, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: index,
                                                class: _normalizeClass(["radio-icon-item", {
                                                        active: !businessHoursData.value[`hide${availableDay.day}`],
                                                    }])
                                            }, [
                                                _createElementVNode("div", {
                                                    class: "icon",
                                                    onClick: ($event) => (toggleVisibility(availableDay))
                                                }, _toDisplayString(_unref(getLocalizedDay)(availableDay.day, 'short')), 9 /* TEXT, PROPS */, _hoisted_6)
                                            ], 2 /* CLASS */));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleDays), (availableDay, index) => {
                                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                                        id: 'available-day-hours-' + index,
                                        key: index,
                                        class: _normalizeClass([
                                            'flex flex-col items-center py-2',
                                            {
                                                'border-b border-gray-200': index !== _unref(visibleDays).length - 1,
                                            },
                                        ])
                                    }, [
                                        _createElementVNode("div", _hoisted_8, [
                                            _createVNode(_unref(UITextSmMedium), { class: "flex items-center" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(getLocalizedDay)(availableDay.day, 'long')), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        (availableDay.hours.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableDay.hours, (availableDayHour, hourIndex) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: hourIndex,
                                                        class: "mb-2"
                                                    }, [
                                                        _createElementVNode("div", _hoisted_10, [
                                                            _createVNode(_unref(UITimePicker), {
                                                                "formatted-value": availableDayHour.startTime,
                                                                "onUpdate:formatted-value": ($event) => ((availableDayHour.startTime) = $event),
                                                                "value-format": "H:m",
                                                                minutes: 5,
                                                                format: "hh:mm a",
                                                                "use-12-hours": "",
                                                                actions: ['confirm'],
                                                                class: "w-28"
                                                            }, null, 8 /* PROPS */, ["formatted-value", "onUpdate:formatted-value"]),
                                                            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('businessHour.to')), 1 /* TEXT */),
                                                            _createVNode(_unref(UITimePicker), {
                                                                "formatted-value": availableDayHour.endTime,
                                                                "onUpdate:formatted-value": ($event) => ((availableDayHour.endTime) = $event),
                                                                "value-format": "H:m",
                                                                minutes: 5,
                                                                format: "hh:mm a",
                                                                "use-12-hours": "",
                                                                actions: ['confirm'],
                                                                "is-hour-disabled": hour => handleIsHourDisabled(hour, availableDayHour.startTime),
                                                                "is-minute-disabled": (min, hour) => handleIsMinDisabled(min, hour, availableDayHour.startTime),
                                                                class: "w-28"
                                                            }, null, 8 /* PROPS */, ["formatted-value", "onUpdate:formatted-value", "is-hour-disabled", "is-minute-disabled"]),
                                                            _createElementVNode("div", _hoisted_12, [
                                                                (hourIndex === 0)
                                                                    ? (_openBlock(), _createBlock(_unref(UIButton), {
                                                                        key: 0,
                                                                        id: "add-availability-hour-std",
                                                                        text: true,
                                                                        class: "text-gray-700 ml-2",
                                                                        disabled: availableDay.getLastHour().endTime === '0:0' &&
                                                                            availableDay.getLastHour().startTime === '0:0',
                                                                        onClick: () => availableDay.addNewAvailabilityHourWithStartTimeAndEndTime({
                                                                            startTime: availableDay.getLastHour().startTime,
                                                                            endTime: availableDay.getLastHour().endTime,
                                                                        })
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_unref(PlusIcon), { class: "w-4" })
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "onClick"]))
                                                                    : _createCommentVNode("v-if", true),
                                                                _createVNode(_unref(UIButton), {
                                                                    id: "remove-availability-hour-std",
                                                                    class: "ml-2 text-red-600",
                                                                    text: true,
                                                                    onClick: ($event) => (removeAvailabilityHour(availableDay, hourIndex))
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_unref(Trash02Icon), { class: "w-4" })
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                                (hourIndex === 0)
                                                                    ? (_openBlock(), _createBlock(_unref(UIPopover), {
                                                                        key: 1,
                                                                        trigger: "click",
                                                                        show: activeHourIndexForCopy.value === index && hourIndex === 0,
                                                                        class: "!rounded-md !pb-0",
                                                                        onClickoutside: _cache[2] || (_cache[2] =
                                                                            () => {
                                                                                copyToDays.value = [];
                                                                                activeHourIndexForCopy.value = -1;
                                                                            })
                                                                    }, {
                                                                        trigger: _withCtx(() => [
                                                                            _createVNode(_unref(UIButton), {
                                                                                id: "copy-availability-hour-std",
                                                                                class: "ml-2 text-gray-700",
                                                                                text: true,
                                                                                onClick: () => {
                                                                                    activeHourIndexForCopy.value =
                                                                                        activeHourIndexForCopy.value > -1 ? -1 : index;
                                                                                }
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createVNode(_unref(Copy06Icon), { class: "w-4" })
                                                                                ]),
                                                                                _: 2 /* DYNAMIC */
                                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                            _createElementVNode("div", _hoisted_13, [
                                                                                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('businessHour.copyTimesTo')) + "... ", 1 /* TEXT */),
                                                                                (_openBlock(), _createBlock(_unref(UICheckbox), {
                                                                                    id: 'All Days',
                                                                                    key: 'All Days',
                                                                                    name: 'All Days',
                                                                                    checked: copyToDays.value.length === 7,
                                                                                    class: "text-md flex w-20 p-2",
                                                                                    "onUpdate:checked": _cache[1] || (_cache[1] =
                                                                                        x => {
                                                                                            copyToDays.value = x
                                                                                                ? _unref(MyAvailability).DAYS.map(day => day.name)
                                                                                                : [];
                                                                                        })
                                                                                }, {
                                                                                    default: _withCtx(() => [
                                                                                        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('businessHour.copyToAll')), 1 /* TEXT */)
                                                                                    ]),
                                                                                    _: 1 /* STABLE */
                                                                                }, 8 /* PROPS */, ["checked"])),
                                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MyAvailability).DAYS, (day, k) => {
                                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                                        key: k,
                                                                                        class: "flex items-center p-2"
                                                                                    }, [
                                                                                        (_openBlock(), _createBlock(_unref(UICheckbox), {
                                                                                            id: day.name,
                                                                                            key: day.name,
                                                                                            name: day.name,
                                                                                            checked: copyToDays.value.includes(day.name) ||
                                                                                                day.name === availableDay.day,
                                                                                            disabled: day.name === availableDay.day,
                                                                                            class: "text-md flex w-20",
                                                                                            "onUpdate:checked": x => {
                                                                                                if (x) {
                                                                                                    copyToDays.value.push(day.name);
                                                                                                }
                                                                                                else {
                                                                                                    copyToDays.value.splice(copyToDays.value.indexOf(day.name), 1);
                                                                                                }
                                                                                            }
                                                                                        }, {
                                                                                            default: _withCtx(() => [
                                                                                                _createElementVNode("div", _hoisted_16, _toDisplayString(day.name), 1 /* TEXT */)
                                                                                            ]),
                                                                                            _: 2 /* DYNAMIC */
                                                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "name", "checked", "disabled", "onUpdate:checked"]))
                                                                                    ]));
                                                                                }), 128 /* KEYED_FRAGMENT */)),
                                                                                _createVNode(_unref(UIButton), {
                                                                                    id: "submit",
                                                                                    type: "primary",
                                                                                    size: "small",
                                                                                    class: "my-2 w-full text-center",
                                                                                    onClick: ($event) => (copyTimesToDays(availableDay))
                                                                                }, {
                                                                                    default: _withCtx(() => [
                                                                                        _createTextVNode(_toDisplayString(_ctx.$t('businessHour.apply')), 1 /* TEXT */)
                                                                                    ]),
                                                                                    _: 2 /* DYNAMIC */
                                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                                            ])
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"]))
                                                                    : _createCommentVNode("v-if", true)
                                                            ])
                                                        ]),
                                                        (availableDay.isOverlapIndex(hourIndex))
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t('businessHour.overlapError')), 1 /* TEXT */))
                                                            : _createCommentVNode("v-if", true)
                                                    ]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ], 10 /* CLASS, PROPS */, _hoisted_7)), [
                                        [_vShow, !businessHoursData.value[`hide${availableDay.day}`]]
                                    ]);
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["id", "model"]))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
